<template>
  <div>
    <div class="jumbo homepage-jumbo">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="white">Frank's Hangar - Estates & Consignments</h1>
            <div class="hr"></div>
            <p class="white">I've had a passion for aircraft since I was a teenager. Now I use that passion to help
              families to redistribute their loved ones model airplane items. Families really appreciate knowing that
              the items will be used again and by younger people.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="grey-backing">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 center">
            <h3 class="breaker-text">Handling Estates and Consignments for over 15 years with clients all over North
              America.
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="container section-padding normalize-ipad">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 center">
          <h2 class="space-bottom">Popular Categories</h2>
          <p>
            Browse the current offers from the three most popular categories. For all the categories, click the
            "Products" dropdown on the navigation bar.
          </p>
        </div>
      </div>
      <div class="row space-top">
        <CategoryBox :img="'plane-category'" :title="'Model Airplanes'" :to="'/products/planes'" />
        <CategoryBox :img="'train-category'" :title="'Kits'" :to="'/products/kits'" />
        <CategoryBox :img="'car-category'" :title="'Electronics'" :to="'/products/electronics'" />
      </div>
    </div>
    <div class="container section-padding">
      <div class="row">
        <div class="col-lg-5 d-flex align-items-center">
          <div>
            <h2 class="space-bottom">Estates and Consignment Since 2005</h2>
            <p>
              I grew up on a tobacco farm, learning to repair machinery with my father’s guidance. We lived in
              several small farming communities in southern Ontario over the years as we bought and sold
              farms. I am now happily retired.
            </p>
            <p>
              For the past 15 years I have been helping families to redistribute their loved ones model
              airplane items. Families really appreciate knowing that the items will be used again and by
              younger people. I also help modellers to downsize as well. If you have any questions just ask.
            </p>
            <router-link class="space-top" to="/about">
              <div class="button-container space-bottom-ipad">
                <div class="standard-button d-flex flex-row">
                  <div class="cart-left d-flex align-items-center">
                    <p>More About Me</p>
                  </div>
                  <div class="cart-right d-flex align-items-center justify-content-center">
                    <ArrowRightIcon :size="100" fillColor="rgb(255,255,255)" />
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-7 d-flex align-items-center">
          <img src="@/assets/img/homepage-about.jpg" class="img-fluid" />
        </div>
      </div>
    </div>
    <div class="container section-padding">
      <div class="row">
        <div class="col-lg-6">
          <div class="video_wrapper">
            <iframe width="100%" class="video-frame"
              id="youtube_video" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
        <div class="col-lg-5 offset-lg-1 d-flex align-items-center">
          <div>
            <h2 class="space-bottom">Frank's Hangar on YouTube</h2>
            <p>
              Check out my latest videos on YouTube for a demo of upcoming products. Or click the button below to visit
              my youtube channel.
            </p>
            <a target="_blank" class="space-top" href="https://www.youtube.com/channel/UC7m_p93uxTW1A6DbZDhGp4w">
              <div class="button-container space-bottom-ipad">
                <div class="standard-button d-flex flex-row">
                  <div class="cart-left d-flex align-items-center">
                    <p>YouTube Channel</p>
                  </div>
                  <div class="cart-right d-flex align-items-center justify-content-center">
                    <ArrowRightIcon :size="100" fillColor="rgb(255,255,255)" />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="homepage-contact relative">
      <div class="container homepage-contact-padding">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="space-bottom white">Contact Me For More Info</h2>
            <p class="white no-bottom">Click the "contact me" button to visit the contact page</p>
          </div>
          <div class="col-lg-6 d-flex align-items-center justify-content-lg-end">
            <router-link to="/contact">
              <div class="button-container space-top-ipad">
                <div class="standard-button d-flex flex-row">
                  <div class="cart-left d-flex align-items-center">
                    <p>Contact Me</p>
                  </div>
                  <div class="cart-right d-flex align-items-center justify-content-center">
                    <ArrowRightIcon :size="100" fillColor="rgb(255,255,255)" />
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  // import HelloWorld from '@/components/HelloWorld.vue'
  import CategoryBox from "@/components/CategoryBox.vue";
  import ArrowRightIcon from "vue-material-design-icons/ArrowRight.vue";
  import $ from 'jquery';
  export default {
    components: {
      CategoryBox,
      ArrowRightIcon,
    },
    mounted() {
      var channelID = "UC7m_p93uxTW1A6DbZDhGp4w";
      var reqURL = "https://www.youtube.com/feeds/videos.xml?channel_id=";
      $.getJSON("https://api.rss2json.com/v1/api.json?rss_url=" + encodeURIComponent(reqURL) + channelID, function (data) {
        var link = data.items[0].link;
        var id = link.substr(link.indexOf("=") + 1);
        $("#youtube_video").attr("src", "https://youtube.com/embed/" + id + "?controls=1&showinfo=0&rel=0");
      });
    },
    name: "Home",
    // components: {
    //   HelloWorld
    // }
  };
</script>